import React from "react";

import svg from "../../assets/images/icons/Data Mapper.svg";

export const MappingIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Mapping"}
    />
);
